import React from "react";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const About = () => {
  return (
    <div>
      <Header />
      <Footer />
    </div>
  );
};

export default About;
